import { gql } from "@apollo/client";

const GETUSERCLOSECHAT = gql`
  query getUserClosedChats($agentId: [ID], $timeFrame: String) {
    getUserClosedChats(agentId: $agentId, timeFrame: $timeFrame) {
      success
      error
      count
    }
  }
`;

export default GETUSERCLOSECHAT;
